import {
    IS_ENABLED_ECOMMERCE_OPTIONS,
    IS_MULTI_TENANT,
    SITE_TYPE
} from "@/common/constants";

export const homeCardsItems = [
    {
        name: "Editor de catálogo",
        id: "customization-editor",
        icon: "🧩",
        description: "Edita tu sitio web con la información de tu negocio.",
        isDefault: IS_MULTI_TENANT,
        permission: "tenant:GetBrandingSettings",
        url: "/app/customization/editor",
        group: "customization"
    },
    {
        name: "Ordenes",
        id: "orders",
        icon: "💳",
        description:
            "Consulta tus órdenes mediante filtros avanzados y criterios personalizados.",
        isDefault: true,
        permission: "order:List",
        url: "/app/orders",
        group: "orders"
    },

    {
        name: "Productos",
        permission: "product:List",
        id: "products",
        icon: "🛍️",
        description:
            "Consulta los productos registrados. Puedes filtrar por marca de productos, categoría del producto o palabra clave.",
        isDefault: true,
        url: "/app/products",
        group: "products"
    },
    {
        name: "Clientes",
        id: "customers",
        icon: "👩",
        description: `Consulta y busca los clientes registrados en el ${SITE_TYPE}. Identifica las ventas registradas para un cliente.`,
        isDefault: !IS_ENABLED_ECOMMERCE_OPTIONS,
        permission: "customer:List",
        url: "/app/customers",
        group: "customers"
    },
    {
        name: "Productos por despachar",
        id: "orders_references",
        icon: "📨",
        description:
            "Consulta los productos que estan pendientes por despachar.",
        isDefault: true,
        permission: "order:ListReferences",
        url: "/app/orders/references",
        group: "orders"
    },
    {
        name: "Calendario de entregas",
        id: "orders_schedule",
        icon: "🗓",
        description:
            "Gestiona tus entregas pendientes con nuestra vista de calendario. Organiza tu flujo de trabajo según la fecha de compromiso.",
        isDefault: true,
        permission: "order:List",
        url: "/app/orders/schedule",
        group: "orders"
    },

    {
        name: "Historial de ventas",
        id: "orders",
        icon: "💰",
        description:
            "Explora tus ventas y órdenes fácilmente usando el filtrado por fecha o criterios personalizados.",
        isDefault: true,
        permission: "order:ListOwn",
        url: "/app/orders?deliveryStatus=completed",
        group: "orders"
    },

    {
        name: "Nueva venta",
        id: "orders_new",
        icon: "🛒",
        description:
            "Crea un pedido con precios del catálogo, buscando entre todos los productos disponibles en la plataforma.",
        isDefault: true,
        permission: "order:Create",
        url: "/app/orders/new",
        group: "orders"
    },

    {
        name: "Nueva cotización",
        id: "orders_new_quote",
        icon: "🧾",
        description:
            "Crea una cotización con precios del catálogo para enviarle al cliente antes de confirmar la venta.",
        isDefault: true,
        permission: "order:Create",
        url: "/app/orders/new?isQuote=true",
        group: "orders"
    },

    {
        name: "Ver cotizaciones",
        id: "orders_quotes",
        icon: "🧾",
        description:
            "Consulta las cotizaciones registradas, filtradas por estado de cotización.",
        isDefault: true,
        permission: "order:List",
        url: "/app/orders?deliveryStatus=quote",
        group: "orders"
    },

    {
        name: "Venta en tienda",
        id: "orders_new_in_merchant",
        icon: "🏪",
        description:
            "Registra una venta usando el inventario de tu tienda con precios propios.",
        isDefault: true,
        permission: "order:CreateInMerchant",
        url: "/app/orders/new-in-merchant",
        group: "orders"
    },
    {
        name: "Inventario",
        id: "inventories_list",
        icon: "🧮",
        description:
            "Consulta los productos registrados en el inventario de tu tienda. Puedes filtrar los productos por marca, categoría o palabra clave.",
        isDefault: true,
        permission: "inventory:Get",
        url: "/app/inventories",
        group: "inventories"
    },
    {
        name: "Carga masiva de inventario",
        id: "inventories_massive",
        icon: "🧮",
        description:
            "Actualiza o ingresa productos a tu inventario. con un archivo podrás actualizar el inventario de tu tienda.",
        isDefault: true,
        permission: "inventory:Create",
        url: "/app/inventories/massive",
        group: "inventories"
    },
    {
        name: "Carga masiva de productos",
        id: "products",
        permission: "product:LoadMassive",
        icon: "🛍️",
        description:
            "Facilita la creación y actualización de productos mediante la utilización de un archivo de Excel.",
        isDefault: true,
        url: "/app/products/massive/load",
        group: "products"
    },

    {
        name: "Perfil del negocio",
        id: "customization-header",
        icon: "📝",
        description:
            "Edita el nombre, descripción, logo, redes sociales y WhatsApp de tu catálogo.",
        isDefault: IS_MULTI_TENANT,
        permission: "tenant:GetBrandingSettings",
        url: "/app/customization/header",
        group: "customization"
    },
    {
        name: "Diseño",
        id: "customization-design",
        icon: "🎨",
        description:
            "Elige el estilo visual y los colores que representan tu negocio.",
        isDefault: IS_MULTI_TENANT,
        permission: "tenant:GetBrandingSettings",
        url: "/app/customization/design",
        group: "customization"
    },
    {
        name: "Nuevo producto",
        id: "products",
        permission: "product:Record",
        icon: "🛍️",
        description:
            "Elige entre creación rápida o completa con variantes, categoría, marca e inventario.",
        isDefault: true,
        url: "/app/products/new",
        group: "products"
    },
    {
        name: "Nuevo cliente",
        id: "customers",
        icon: "👩",
        description:
            "Agrega un cliente para asignarle ventas y consultar su historial de compras.",
        isDefault: !IS_ENABLED_ECOMMERCE_OPTIONS,
        permission: "customer:Create",
        url: "/app/customers/new",
        group: "customers"
    },
    {
        name: "Buscar orden",
        id: "orders-detail",
        icon: "📇",
        description:
            "Busca y consulta el detalle de una orden en específico usando su ID.",
        isDefault: true,
        permission: "order:Get",
        url: "/app/orders/detail",
        group: "orders"
    },
    {
        name: "Variantes destacadas",
        id: "products",
        permission: "referencias:ListHighlight",
        icon: "🛍️",
        description:
            "Registra referencias de productos destacadas por categoría y para la pantalla principal.",
        isDefault: IS_ENABLED_ECOMMERCE_OPTIONS,
        url: "/app/products/highlight",
        group: "products"
    },
    {
        name: "Caja",
        id: "merchant_box",
        icon: "👩‍🏭",
        description:
            "Consulta el dinero ingresado por ventas en efectivo y plataformas electrónicas.",
        isDefault: !IS_ENABLED_ECOMMERCE_OPTIONS,
        permission: "merchant:GetBox",
        url: "/app/merchant/box",
        group: "merchantOperations"
    },
    {
        name: "Servicios",
        id: "merchant_services",
        icon: "👩‍🏭",
        description:
            "Administra los servicios adicionales de tu tienda y asócialos a tus ventas.",
        isDefault: !IS_ENABLED_ECOMMERCE_OPTIONS,
        permission: "merchant:GetServices",
        url: "/app/merchant/services",
        group: "merchantOperations"
    },
    {
        name: "Nuevo gasto",
        id: "cash_outputs",
        icon: "🏪",
        description:
            "Registra un gasto para llevar control de tus finanzas (facturas, insumos, etc.).",
        isDefault: true,
        permission: "cashOutput:Create",
        url: "/app/cash-outputs/new",
        group: "cashOutputs"
    },
    {
        name: "Colaboradores",
        id: "users",
        icon: "👩‍🔧",
        description:
            "Administra los permisos de tus colaboradores e invita a nuevos miembros.",
        isDefault: true,
        permission: "user:ListOwn",
        url: "/app/employees",
        group: "merchantOperations"
    },
    {
        name: "Listas de compras",
        id: "supply_list_new",
        icon: "🧮",
        description:
            "Consulta las listas de compras para pendientes para abastecer tu inventario.",
        isDefault: !IS_ENABLED_ECOMMERCE_OPTIONS,
        permission: "supplyList:List",
        url: "/app/supply-lists",
        group: "supplyLists"
    },
    {
        name: "Tenants",
        id: "tenants",
        icon: "🏢",
        description:
            "Consulta y administra los tenants registrados en la plataforma.",
        isDefault: true,
        permission: "tenant:List",
        url: "/app/tenants",
        group: "tenants"
    },
    {
        name: "Seleccionar tenant",
        id: "tenant_select",
        icon: "🏢",
        description:
            "Selecciona un tenant para operar en su contexto y acceder a sus funcionalidades.",
        isDefault: true,
        permission: "tenant:Select",
        url: "/app/tenants",
        group: "tenants"
    },
    {
        name: "Banco de imágenes compartidas",
        id: "shared_images",
        icon: "🖼️",
        description:
            "Sube imágenes de stock reutilizables por cualquier tenant desde el selector de imágenes.",
        isDefault: true,
        permission: "sharedImage:Create",
        url: "/app/shared-images",
        group: "shared_images"
    },
    {
        name: "Configuración",
        id: "settings-orders",
        icon: "⚙️",
        description:
            "Tiempos de entrega, precios por ciudad, métodos de pago del checkout y valores mínimos de orden.",
        isDefault: true,
        permission: "tenant:GetOrdersSettings",
        url: "/app/settings",
        group: "settings"
    },
    {
        name: "Tipos de producto",
        id: "settings-catalog",
        icon: "⚙️",
        description: "Elige qué tipos de producto puede manejar tu catálogo.",
        isDefault: true,
        permission: "tenant:GetProductTypes",
        url: "/app/settings/catalog",
        group: "settings",
        feature: "products"
    },

    {
        name: "Venta rápida",
        id: "orders_record",
        icon: "⚡",
        description:
            "Registra una venta sin asociar inventario. El dinero en caja se incrementa automáticamente.",
        isDefault: false,
        permission: "order:Create",
        url: "/app/orders/record",
        group: "orders"
    },
    {
        name: "Consulta imágenes registradas",
        id: "images",
        icon: "📷",
        description:
            "Consulta las imágenes que tiendes disponibles para asociar a productos, categorías, colecciones, tiendas entre otros.",
        isDefault: true,
        permission: "image:List",
        url: "/app/images",
        group: "files"
    },
    {
        name: "Grupos de órdenes",
        id: "orders-groups",
        icon: "💳",
        description:
            "Consulta órdenes que agrupan pedidos abastecidos por diferentes tiendas o bodegas.",
        isDefault: false,
        permission: "orderGroup:List",
        url: "/app/orders-groups",
        group: "orders"
    },
    {
        name: "Ventas por producto",
        id: "sales_product",
        icon: "💰",
        description:
            "Consulta las ventas de un producto a lo largo del tiempo.",
        isDefault: false,
        permission: "order:ListReferences",
        url: "/app/orders/product",
        group: "orders"
    },
    {
        name: "Nuevo inventario",
        id: "inventories_new",
        icon: "🧮",
        description:
            "Agrega productos a tu inventario y lleva un registro de lo que has surtido en tu tienda.",
        isDefault: false,
        permission: "inventory:Create",
        url: "/app/inventories/new",
        group: "inventories"
    },
    {
        name: "Nuevo carrito",
        id: "cart_new",
        icon: "🛒",
        description:
            "Crea un nuevo carro de compras para compartir con los clientes.",
        isDefault: false,
        permission: "cart:List",
        url: "/app/carts/new",
        group: "cart"
    },
    {
        name: "Lista carros de compras",
        id: "carts",
        permission: "carts:List",
        icon: "🛒",
        description:
            "Lista los carros de compras creados para compartir con los clientes.",
        isDefault: false,
        url: "/app/carts",
        group: "cart"
    },
    {
        name: "Carga masiva de productos e inventario",
        id: "products",
        permission: "product:LoadMassive",
        icon: "🛍️",
        description:
            "Facilita la creación y actualización de productos e inventario mediante la utilización de un archivo de Excel.",
        isDefault: false,
        url: "/app/products/massive/load-with-inventories",
        group: "products"
    },

    {
        name: "Lista de tiendas",
        id: "stores_list",
        icon: "🏪",
        description:
            "Consulta tus tiendas registradas o las que tengas acceso.",
        isDefault: false,
        permission: "store:List",
        url: "/app/stores",
        group: "stores"
    },
    {
        name: "Nueva tienda",
        id: "stores_record",
        icon: "🏪",
        description:
            "Crea una tienda para gestionar inventario y realizar ventas.",
        isDefault: false,
        permission: "store:CreateOwn",
        url: "/app/stores/record",
        group: "stores"
    },
    {
        name: "Marcas",
        id: "brands",
        icon: "🔖",
        description:
            "Consulta las marcas disponibles para asociar a tus productos.",
        isDefault: false,
        permission: "brand:List",
        url: "/app/brands",
        group: "brands"
    },
    {
        name: "Nueva marca",
        id: "brands",
        icon: "🔖",
        description: "Crea una marca para asociar a tus productos.",
        isDefault: false,
        permission: "brand:Create",
        url: "/app/brands/new",
        group: "brands"
    },
    {
        name: "Marcas destacadas",
        id: "brands",
        icon: "🔖",
        description:
            "Registra marcas destacadas para las categorías y la pantalla principal.",
        isDefault: false,
        permission: "brand:ListHighlight",
        url: "/app/brands/highlight",
        group: "brands"
    },
    {
        name: "Colecciones",
        id: "collections",
        icon: "🏷",
        description:
            "Consulta las colecciones disponibles para organizar productos.",
        isDefault: false,
        permission: "collection:List",
        url: "/app/collections",
        group: "collections"
    },
    {
        name: "Nueva colección",
        id: "collections",
        icon: "🏷",
        description: "Crea una colección para organizar y agrupar productos.",
        isDefault: false,
        permission: "collection:Create",
        url: "/app/collections/new",
        group: "collections"
    },
    {
        name: "Colecciones destacadas",
        id: "collections",
        icon: "🏷",
        description: "Lista de colecciones destacados",
        isDefault: false,
        permission: "ListHighlight",
        url: "/app/collections/highlight",
        group: "collections"
    },
    {
        name: "Lista de categorías",
        id: "lines",
        icon: "➖",
        description:
            "Consulta las categorías y subcategorías disponibles para agrupar productos.",
        isDefault: false,
        permission: "line:List",
        url: "/app/lines",
        group: "lines"
    },
    {
        name: "Nueva categoría",
        id: "lines",
        icon: "➖",
        description:
            "Crea una categoría para agrupar productos en tu catálogo.",
        isDefault: false,
        permission: "line:Create",
        url: "/app/lines/new",
        group: "lines"
    },
    {
        name: "Gastos",
        id: "cash_outputs",
        icon: "🏪",
        description:
            "Consulta los gastos de tu tienda (servicios, insumos, dividendos).",
        isDefault: false,
        permission: "cashOutput:List",
        url: "/app/cash-outputs",
        group: "cashOutputs"
    },
    {
        name: "Lista de tiendas",
        id: "stores_list",
        icon: "🏪",
        description:
            "Consulta tus tiendas registradas o las que tengas acceso.",
        isDefault: false,
        permission: "store:List",
        url: "/app/stores",
        group: "stores"
    },
    {
        name: "Nuevo proveedor",
        id: "supplier_new",
        icon: "🏭",
        description:
            "Agrega un proveedor para asociarlo a tus productos y compras.",
        isDefault: false,
        permission: "supplier:Create",
        url: "/app/suppliers/new",
        group: "suppliers"
    },
    {
        name: "Proveedores",
        id: "suppliers_list",
        icon: "🏭",
        description: "Consulta los proveedores registrados en el sistema.",
        isDefault: false,
        permission: "supplier:List",
        url: "/app/suppliers",
        group: "suppliers"
    },
    {
        name: "Nueva bodega",
        id: "warehouses_new",
        icon: "🏬",
        description:
            "Crea una bodega para ampliar la cobertura de tu red de distribución.",
        isDefault: false,
        permission: "warehouse:Create",
        url: "/app/warehouses/new",
        group: "warehouses"
    },
    {
        name: "Bodegas",
        id: "warehouses_list",
        icon: "🏬",
        description:
            "Consulta tus bodegas registradas o las que tengas acceso.",
        isDefault: false,
        permission: "warehouse:List",
        url: "/app/warehouses",
        group: "warehouses"
    },
    {
        name: "Histórico de inventario",
        id: "inventories_list",
        icon: "🧮",
        description:
            "Consulta el historico de registro de productos del inventario. Puedes filtrar por fecha para obtener detalle de cuando has surtido tu tienda.",
        isDefault: false,
        permission: "inventory:ListDate",
        url: "/app/inventories/history",
        group: "inventories"
    },
    {
        name: "Usuarios",
        id: "users",
        icon: "👩‍💻",
        description: "Consulta lo usuarios registrados.",
        isDefault: false,
        permission: "user:List",
        url: "/app/users",
        group: "users"
    },
    {
        name: "Roles de usuario",
        id: "roles",
        icon: "👤",
        description:
            "Lista los roles registrados y sincroniza la información con el servidor.",
        isDefault: false,
        permission: "role:List",
        url: "/app/roles",
        group: "users"
    },

    {
        name: "Cargar imagen",
        id: "images",
        icon: "📷",
        description:
            "Puedes subir imágenes y posteriormente asociarlas a productos, colecciones, marcas, tiendas, entre otros.",
        isDefault: false,
        permission: "image:Create",
        url: "/app/images/new",
        group: "files"
    },
    {
        name: "Cargar archivo",
        id: "files",
        icon: "🗂",
        description:
            "Puedes subir archivos y posteriormente asociarlos a productos y páginas personalizadas.",
        isDefault: false,
        permission: "file:Create",
        url: "/app/files/new",
        group: "files"
    },
    {
        name: "Archivos cargados",
        id: "files",
        icon: "🗂",
        description:
            "Consulta los archivos  disponibles para asociar a productos o páginas personalizadas.",
        isDefault: false,
        permission: "file:List",
        url: "/app/files",
        group: "files"
    },
    {
        name: "Nueva lista de compras",
        id: "supply_list_list",
        icon: "🧮",
        description:
            "Puedes registrar los productos que debes de comprar para mantener tu inventario al día.",
        isDefault: false,
        permission: "supplyList:Create",
        url: "/app/supply-lists/new",
        group: "supplyLists"
    }
];
